<template>
  <div class="box9">
    <div class="titleBox">
      <div class="title">180天全方位、精细化、高标准陪跑</div>
      <div class="subtitle">
        严格督导，【按天规划具体执行动作】<br />
        快速打造高流量短视频IP带货账号！
      </div>
    </div>
    <div class="item" v-for="(item, index) in list" :key="index">
      <img
        :src="
          require(`../../../assets/coursePage/newMedia2/box5/${index + 1}.png`)
        "
        alt=""
      />
      <div class="title">{{ item.title }}</div>
      <p>{{ item.p }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "直播一对一答疑",

          p: "7-10年运营专业讲师，针对每一位学员账号问题直播一对一答疑，保证学员账号良性快速发展。",
        },
        {
          title: "连麦拔高性指导",

          p: "百万粉丝大V（短视频运营婧姐）直播间每周1次，每次2个小时直播连麦。",
        },
        {
          title: "180天全程督促",

          p: "专业运营讲师按天规划具体执行动作，全程跟进、提醒学员发布作品，指导学员产出优质作品。",
        },
        {
          title: "优秀案例及时分享",

          p: "专业运营讲师时刻关注和挖掘行业优秀案例，整理优质账号（分析文档）发给学员学习。",
        },
        {
          title: "每月更新行业风口",

          p: "每月更新行业新知识。",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box9 {
  position: relative;
  width: 100%;
  padding: 80px 0 58px;
  background: url("../../../assets/coursePage/newMedia2/box5/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  .titleBox {
    text-align: center;
    /* margin-top: -10px; */
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #4d1f2e;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4d1f2e;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
  .item {
    width: 690px;
    padding-bottom: 45px;
  	background-color: #ffffff;
	box-shadow: 0px 10px 30px 0px 
		#ffdbe7;
    border-radius: 26px;
    margin: 0 auto 40px;
    position: relative;
    padding-left: 201px;
    box-sizing: border-box;
    overflow: hidden;
    padding-right: 70px;
    img {
      width: 134px;
      height: 97px;
      position: absolute;
      left: 32px;
      top: 50px;
    }
    .title {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #33141f;
      line-height: 36px;
      margin: 45px 0 22px;
    }
    
    p {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #664752;
      line-height: 40px;
      margin-top: 20px;
    }
  }
}
</style>
